import { curry } from 'rambda';
function _side<T>(f: (a: T) => void, b: T) {
  f(b);
  return b;
}

export const side = curry(_side);
